












import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { IProjectInfo } from '@master/config/IProjectInfo'
import { inject } from 'inversify-props'

@Component
export default class AppCurrencyNA extends Vue {
  @Prop() inputValue
  @Prop({ default: true }) useCurrency!: boolean
  @Prop({ default: 10 }) maxlength?: number
  @Prop({ default: false }) disabled: boolean

   @inject()
  private projectInfo: IProjectInfo

   inputModal = ''
   textIsSelected = false

   get counterMsg () {
     if (typeof this.maxlength === 'undefined') return
     const number = this.convertCurrencyToNumber(this.inputModal)
     const remainingChar = this.maxlength - (number.toString().length || 0)
     return remainingChar > 0 ? `${remainingChar} letter(s) remaining` : 'Max character limit reached'
   }

   numberAndNAOnly (evt) {
     evt = (evt) || window.event
     const charCode = (evt.which) ? evt.which : evt.keyCode

     const currentValue = evt.target.value
     if (this.textIsSelected) {
       if (!this.isAlphabetN(charCode) && this.isNonNumber(charCode)) {
         evt.preventDefault()
       } else {
         this.textIsSelected = false
       }
       return true
     }

     // if current value is 'NA', cannot key in other character
     if (currentValue.toUpperCase() === 'NA') {
       evt.preventDefault()
     }

     // if current value is N, the followed char must be A
     if (this.isAlphabetN(currentValue.charCodeAt(0))) {
       if (this.isAlphabetA(charCode)) {
         return true
       }
       evt.preventDefault() // only can accept A
     }

     // if there is empty value, it can either key in char N or number only
     if (!currentValue) {
       if (this.isAlphabetN(charCode)) {
         return true
       }
     }

     // cannot key in non number value
     if (this.isNonNumber(charCode)) {
       evt.preventDefault()
     } else {
       return true
     }
   }

   isAlphabetN (charCode) {
     return charCode === 78 || charCode === 110
   }

   isAlphabetA (charCode) {
     return charCode === 65 || charCode === 97
   }

   isNonNumber (charCode) {
     return charCode > 31 && (charCode < 48 || charCode > 57)
   }

   onBlur () {
     if (!this.inputModal && this.inputModal !== '0') {
       this.inputModal = this.formatValue('')
       this.$emit('input', '')
       return
     }

     // format na to NA to display
     if (this.inputModal.toUpperCase() === 'NA') {
       this.inputModal = 'NA'
       this.$emit('input', 'NA')
       return
     }

     // in case only key in 'n' and on blur, format it to NA
     if (isNaN(Number(this.inputModal))) {
       this.inputModal = 'NA'
       this.$emit('input', 'NA')
       return
     }

     const number = this.convertCurrencyToNumber(this.inputModal)
     this.inputModal = this.formatValue(number)
     this.$emit('input', Number(number))
   }

   onFocus () {
     this.inputModal = this.convertCurrencyToNumber(this.inputModal)
   }

   onSelect () {
     this.textIsSelected = true
   }

   formatValue (source) {
     if (typeof source === 'string') {
       if (source.toUpperCase() === 'NA' || source === '') {
         return source
       }
       source = Number(source.replace('$', '').replace(',', ''))
     } else if (source === undefined || source == null) {
       source = ''
     }
     return this.useCurrency ? this.currencyPrefix + source?.toLocaleString('en-US') : source?.toLocaleString('en-US')
   }

   convertCurrencyToNumber (currency) {
     return currency.replaceAll(this.currencyPrefix, '').replaceAll(',', '')
   }

   get currencyPrefix () {
     return this.projectInfo.currency ?? 'SGD$'
   }

  @Watch('inputValue')
   inputValueOnChange () {
     if (this.inputValue || this.inputValue === '0' || Number(this.inputValue) === 0) {
       this.inputModal = this.formatValue(this.inputValue)
     } else {
       this.inputModal = this.formatValue('')
     }
   }

  mounted () {
    this.inputModal = this.formatValue(this.inputValue)
  }
}
